<div
  [ngStyle]="{ 'height.px': sizeY + 174, 'width.px': sizeX, padding: '-24px' }"
>
  <mat-toolbar
    matDialogTitle
    class="m-0 mb-24"
    set-color
    [backgroundColor]="processType?.color"
  >
    <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
      <span class="h3 title pr-4"
        >{{ isNew === false ? (readOnly ? 'View' : 'Edit') : 'Add' }}
        {{ processTypeName }}</span
      >
      <button
        mat-icon-button
        class="mat-icon-button"
        (click)="cancelDlg()"
        aria-label="Close dialog"
        tabindex="-1"
      >
        <mat-icon set-color [backgroundColor]="processType?.color"
          >close</mat-icon
        >
      </button>
    </div>
  </mat-toolbar>

  <gridster
    [options]="options"
    class="mat-drawer-container bg-white"
    style="background-color: transparent;"
    [ngStyle]="{ 'max-height.px': sizeY, width: '100%' }"
  >
    <gridster-item
      [item]="item.config"
      *ngFor="let item of grid.items; let i=index"
      class="process-widget no-shadow" [tabindex]="i"
    >
      <div class="mat-card no-padding" style="height: 100%">
        <ndc-dynamic
          [ndcDynamicComponent]="item.widget"
          [ndcDynamicInputs]="item.metadata"
          [ndcDynamicOutputs]="handleValueChanged"
        ></ndc-dynamic>
      </div>
    </gridster-item>
  </gridster>
  <!-- <mat-error *ngIf="validationErrors!=''" style="white-space: pre-wrap">{{ validationErrors}}</mat-error> -->
  <div
    *ngIf="!readOnly"
    mat-dialog-actions
    class="m-0 p-24"
    fxLayout="row"
    fxLayoutAlign="space-between center"
  >
    <div>
      <button
        mat-raised-button
        id="btnSubjectSave"
        type="submit"
        [disabled]="!canSave"
        [mat-dialog-close]="1"
        (click)="save()"
        class="save-button mat-accent"
        aria-label="SAVE"
      >
        SAVE
      </button>
    </div>
  </div>
</div>
